const KEY = 'mt_reading_streak';

const monthStr = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;

const prevMonthStr = () => {
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() - 1);
  return monthStr(d);
};

const load = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || { count: 0, lastMonth: '' };
  } catch {
    return { count: 0, lastMonth: '' };
  }
};

export const recordReading = () => {
  const cur = monthStr(new Date());
  const s = load();
  let extended = false;
  if (s.lastMonth !== cur) {
    if (s.lastMonth === prevMonthStr() && s.count > 0) {
      s.count += 1;
    } else {
      s.count = 1;
    }
    extended = true;
    s.lastMonth = cur;
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch { /* storage unavailable (private mode) */ }
  }
  return { ...s, extended };
};

export const getStreak = () => {
  const s = load();
  const cur = monthStr(new Date());
  if (!s.count) return { count: 0, status: 'none' };
  if (s.lastMonth === cur) return { count: s.count, status: 'active' };
  if (s.lastMonth === prevMonthStr()) return { count: s.count, status: 'at_risk' };
  return { count: 0, status: 'none' };
};
